import(/* webpackMode: "eager", webpackExports: ["PathnameButton"] */ "/home/runner/work/dex-frontend/dex-frontend/apps/web/src/app/_ui/pathname-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PoolsFiltersProvider"] */ "/home/runner/work/dex-frontend/dex-frontend/apps/web/src/app/(networks)/_ui/pools-filters-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GlobalStatsCharts"] */ "/home/runner/work/dex-frontend/dex-frontend/apps/web/src/app/(networks)/(evm)/explore/_ui/global-stats-charts.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/home/runner/work/dex-frontend/dex-frontend/apps/web/src/app/(networks)/(evm)/header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LinkInternal"] */ "/home/runner/work/dex-frontend/dex-frontend/packages/ui/dist/components/link.js");
